// mutations
import { LOGIN_MUTATION, LOGOUT_MUTATION } from '@/graphql/mutations/login'

// models
import { AuthLogin } from '@/models'

// const baseURL = '/users'
import { apolloClient } from '@/apollo'

class AuthService {
    async login (form: AuthLogin) {
        const result = await apolloClient.mutate({
            mutation: LOGIN_MUTATION,
            variables: {
                input: {
                    username: form.email,
                    password: form.password
                }
            }
        })
        return {
            token: result.data.login.access_token,
            refreshToken: result.data.login.refreshToken,
            typeToken: result.data.login.token_type,
            expiresIn: result.data.login.expires_id,
            user: result.data.login.user
        }
    }

    async logout () {
        await apolloClient.mutate({
            mutation: LOGOUT_MUTATION
        })
        return true
    }
}

export default new AuthService()
